import { render, staticRenderFns } from "./AppTemplate.vue?vue&type=template&id=4810ca04&scoped=true"
import script from "./AppTemplate.vue?vue&type=script&lang=js"
export * from "./AppTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4810ca04",
  null
  
)

export default component.exports